import { routes, } from "./routes";
import type { Route, } from "@types";

export const getUrlRoute = (): Route =>  {
	const { pathname, } = window.location;
	const mainRoute  = pathname.split("/").slice(0,2).join("/");
	const route = routes.find(rec => rec.route === mainRoute);
	return route || routes[1];
}
